export default class NumberCore {

	private static _uniqueId: number = 0

	static getRandomStr(count: number = 2): string {
		let str: string = '_';

		while (count--) str += NumberCore.getRandomToken();

		return str;
	}

	static getRandomToken(): string {
		return Math.random().toString(32).slice(3, 12);
	}

	static getRandomIntInclusive(min: number = 1, max: number = 1000000) {
		min = Math.ceil(min);
		max = Math.floor(max);

		return Math.floor(Math.random() * (max - min + 1) + min);
	}

	static get uniqueId(): number {
		return ++NumberCore._uniqueId;
	}

}